import { z } from "zod";

export const menuItemSchema = z.tuple([
	z.string(),
	z.string(),
	z.array(z.any()),
	z.array(z.any()),
	z.string(),
]);
export const menuItemsSchema = z.array(menuItemSchema);

export type MenuItemType = z.infer<typeof menuItemSchema>;
